import { useRef, useState } from 'react';
import { WebMToMP3Converter } from '../helpers';
// import { WebMToMP3Converter } from "utils/utils";

type recordingType = 'video' | 'audio';

const useCustomMediaRecorder = (recordingType: recordingType, options?: MediaRecorderOptions) => {
  const [mediaRecorder, setMediaRecorder] = useState<any>(null);
  const [recording, setRecording] = useState(false);
  const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
  const [recordedUrl, setRecordedURL] = useState<string | undefined>('');
  const [status, setStatus] = useState<'idle' | 'recording' | 'stopped'>('idle');
  const streamRef = useRef<any>(null);

  const initializeRecorder = async () => {
    try {
      if (!('mediaDevices' in navigator) || !navigator.mediaDevices.getUserMedia)
        throw 'Media devices Error';

      let userMediaOptions =
        recordingType === 'audio' ? { audio: true } : { video: true, audio: true };
      let stream: MediaStream = await navigator.mediaDevices.getUserMedia(userMediaOptions);

      streamRef.current = stream;
      const recorder = options ? new MediaRecorder(stream, options) : new MediaRecorder(stream);
      let localChunks: any = [];
      recorder.ondataavailable = async (event) => {
        if (typeof event.data === 'undefined') return;
        if (event.data.size === 0) return;
        localChunks.push(event.data);
        const blob = new Blob(localChunks, { type: localChunks[0].type });
        const mp3Blob = await WebMToMP3Converter(blob);
        setRecordedBlob(mp3Blob);
        setRecordedURL(URL.createObjectURL(blob));
      };
      return recorder;
    } catch (error) {
      console.error('Error initializing audio recorder:', error);
    }
  };

  const startRecording = async () => {
    const recorder: any = await initializeRecorder();
    setMediaRecorder(recorder);
    if (recorder) {
      recorder.start();
      setRecording(true);
      setStatus('recording');
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setRecording(false);
      mediaRecorder.stream.getTracks().forEach((track: any) => track.stop());
      setStatus('stopped');
    }
  };

  const clearRecording = () => {
    setRecordedBlob(null);
    setStatus('idle');
    setRecordedURL('');
  };

  const isTypeSupported = (type: string) => {
    return MediaRecorder.isTypeSupported(type);
  };

  return {
    status,
    recording,
    recordedBlob,
    streamRef,
    recordedUrl,
    clearRecording,
    startRecording,
    stopRecording,
    isTypeSupported,
  };
};

export default useCustomMediaRecorder;
